import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	actions: {
		id: 'issue-meatball-menu.dropdown-trigger.actions',
		defaultMessage: 'Actions',
		description: 'Label for button icon for issue actions dropdown menu',
	},
	export: {
		id: 'issue-meatball-menu.dropdown-trigger.export',
		defaultMessage: 'Export',
		description: 'Label for export button for issue actions dropdown menu',
	},
});
